import { getEntries } from '@bkwld/cloak/services/craft'
import { getProductCards } from 'library/services/shopify/storefront'
import getProducts from '~/queries/get-products.gql'

# Handle fetching products for several block types.
export getProductsForBlock = (block) ->
	return unless block?.__typename
	switch block.__typename

		# Product Carousel block
		# Product Grid block
		when 'blocks_productCarousel_BlockType', 'blocks_productGrid_BlockType'

			# Create variables
			variables = {
				...buildProductFilterVariables block
				limit: block.limit
			}

			# Add "and" operators if necessary.
			if block.filterOperator == 'and' then variables = addAndOperator variables

			# Execute the query
			products = await getEntries
				query: getProducts
				variables: variables

			# Don't do Shopify fetch for THC products
			if block.activeIngredient == 'thc' or
				['kitchen', 'select'].includes process.env.CMS_SITE
			then return products

			# For CBD & Hemp, fetch corresponding Shopify products and merge data
			slugs = products.map ({ slug }) -> slug
			shopifyProducts = await getProductCards slugs
			mergedProducts = products.map (product) ->
				shopifyProduct = shopifyProducts.find (thisProduct) =>
					thisProduct.handle == product.slug
				return { ...product, ...shopifyProduct }

			# Remove products that didn't have Shopify data
			return mergedProducts.filter (product) -> !!product.variants

# Helper to build the category query object.
export buildProductFilterVariables = (options) ->

	# The activeIngredient
	activeIngredient: switch options.activeIngredient
		when 'none' then null
		when 'both' then ['cbd', 'thc']
		else options.activeIngredient

	# This flattens the category array on the options object (a block or
	# collection reference) into an array of ids.
	productAvailability: options.productAvailability.map ({ id }) -> id
	productCannabinoids: options.productCannabinoids.map ({ id }) -> id
	productCategory: options.productCategory.map ({ id }) -> id
	productPsychoactivity: options.productPsychoactivity.map ({ id }) -> id
	productSolutions: options.productSolutions.map ({ id }) -> id


# Prepend "and" to every non-empty category array.  This will enforce the "and"
# filter operator.
# https://craftcms.com/docs/3.x/categories-fields.html#querying-elements-with-categories-fields
addAndOperator = (variables) ->
	return {
		...variables
		productAvailability: addAndOperatorToCategory variables.productAvailability
		productCannabinoids: addAndOperatorToCategory variables.productCannabinoids
		productCategory: addAndOperatorToCategory variables.productCategory
		productPsychoactivity: addAndOperatorToCategory variables.productPsychoactivity
		productSolutions: addAndOperatorToCategory variables.productSolutions
	}

addAndOperatorToCategory = (category) ->
	if category.length
	then return ['and', ...category]
	else return []
